import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Messaging_instances, _Messaging_baseUrlThunk;
class Messaging extends SDKResource {
    constructor(config) {
        super(config);
        _Messaging_instances.add(this);
    }
    /**
     * Get an information about the Messaging services configuration. This information includes phone number, phone number type and also rate limits of each service.
     */
    getMessagingConfig(request) {
        return this.request('/messaging/config', 'get', __classPrivateFieldGet(this, _Messaging_instances, "m", _Messaging_baseUrlThunk).bind(this))(request);
    }
}
_Messaging_instances = new WeakSet(), _Messaging_baseUrlThunk = function _Messaging_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { Messaging };
//# sourceMappingURL=messaging.js.map
